export const MM = 'mm'
export const IN = 'in'
export const CYLINDER_INFO = 'cylinder-info'
export const TWO_PLANES_INFO = '2-planes-info'
export const TWO_CYLINDERS_INFO = '2-cylinders-info'
export const SPHERE_INFO = 'sphere-info'
export const TORUS_INFO = 'torus-info'
export const POINT_TO_POINT_INFO = 'point-to-point-info'
export const CONE_INFO = 'cone-info'
